import React from 'react';

const DiscordIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "21",
    height: "14",
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.1909 1.81854C15.8963 1.33396 14.512 0.981781 13.0647 0.78125C12.887 1.03832 12.6794 1.38409 12.5362 1.65915C10.9977 1.47406 9.47345 1.47406 7.96329 1.65915C7.82016 1.38409 7.60779 1.03832 7.42846 0.78125C5.97967 0.981781 4.59379 1.33525 3.29916 1.8211C0.687866 4.97791 -0.0200126 8.0563 0.333927 11.091C2.06587 12.1257 3.74434 12.7542 5.39448 13.1655C5.8019 12.7169 6.16528 12.2401 6.47831 11.7375C5.88212 11.5563 5.3111 11.3326 4.77156 11.073C4.9147 10.9882 5.05471 10.8995 5.18998 10.8082C8.48083 12.0396 12.0564 12.0396 15.3079 10.8082C15.4448 10.8995 15.5848 10.9882 15.7264 11.073C15.1852 11.3339 14.6126 11.5576 14.0165 11.7388C14.3295 12.2401 14.6913 12.7182 15.1003 13.1668C16.752 12.7555 18.432 12.127 20.164 11.091C20.5793 7.57301 19.4545 4.52289 17.1909 1.81854ZM6.92664 9.22468C5.93876 9.22468 5.12862 8.48688 5.12862 7.58843C5.12862 6.68998 5.92147 5.95091 6.92664 5.95091C7.93185 5.95091 8.74196 6.68868 8.72466 7.58843C8.72623 8.48688 7.93185 9.22468 6.92664 9.22468ZM13.5713 9.22468C12.5834 9.22468 11.7733 8.48688 11.7733 7.58843C11.7733 6.68998 12.5661 5.95091 13.5713 5.95091C14.5765 5.95091 15.3866 6.68868 15.3693 7.58843C15.3693 8.48688 14.5765 9.22468 13.5713 9.22468Z",
      fill: "white"
    }
  )
);
DiscordIcon.displayName = "Icons.DiscordIcon";

export { DiscordIcon };
//# sourceMappingURL=DiscordIcon.js.map
